// import { global_hooks } from './globals';
import './internals.scss';
import 'components/forms/init';
import 'components/tabs/tabs_to_dd';

// global_hooks.on('init', init);
// function init() {
// 	console.log('internals/init');
// }

// Choklits Plus Page
(function tab_section_bg() {
	function inject_bg_layers(section) {
		if (section.querySelector('.tab-bg-layer')) return; 

		const wrapper = document.createElement('div');
		wrapper.classList.add('tab-bg-layers');
		wrapper.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:0;';

		// Count the tabs
		const tab_count = section.querySelectorAll('.e-n-tab-title').length;

		for (let i = 1; i <= tab_count; i++) {
			const layer = document.createElement('div');
			layer.classList.add('tab-bg-layer', 'tab-bg-layer-' + i);
			layer.style.cssText = 'position:absolute;inset:0;opacity:0;transition:opacity 0.4s ease;';
			wrapper.appendChild(layer);
		}

		section.insertAdjacentElement('afterbegin', wrapper);
	}

	function update_bg(tabs_widget) {
		const section = tabs_widget.closest('.chok-plus');
		if (!section) return;

		const active_tab = tabs_widget.querySelector('.e-n-tab-title[aria-selected="true"]');
		if (!active_tab) return;

		const index = active_tab.getAttribute('data-tab-index');

		// Swap tab-bg-* class on section 
		section.classList.forEach(cls => {
			if (cls.startsWith('tab-bg-')) section.classList.remove(cls);
		});
		section.classList.add('tab-bg-' + index);

		// Fade layers
		section.querySelectorAll('.tab-bg-layer').forEach(layer => {
			layer.style.opacity = '0';
		});
		const active_layer = section.querySelector('.tab-bg-layer-' + index);
		if (active_layer) active_layer.style.opacity = '1';
	}

	function init_tab_bg() {
		document.querySelectorAll('.chok-plus .e-n-tabs').forEach(tabs_widget => {
			const section = tabs_widget.closest('.chok-plus');
			if (section) inject_bg_layers(section);

			update_bg(tabs_widget);

			tabs_widget.addEventListener('click', e => {
				const tab_btn = e.target.closest('.e-n-tab-title');
				if (!tab_btn) return;
				setTimeout(() => update_bg(tabs_widget), 50);
			});
		});
	}

	document.addEventListener('DOMContentLoaded', init_tab_bg);
})();